import { QueryObserverResult, useQuery } from "react-query";

import { acatsAPIInstance } from "../api";

import { AcatsTransfer } from "./acats";

export const getAcatsTransfer = async (
  accountID: string,
  acatsID: string
): Promise<AcatsTransfer> => {
  const res = await acatsAPIInstance.get<AcatsTransfer>(
    `/acats/${accountID}/${acatsID}`
  );

  return res.data;
};

export const useAcatsTransfer = (
  accountID: string,
  acatsID: string
): QueryObserverResult<AcatsTransfer> =>
  useQuery(["acats", accountID, acatsID], () =>
    getAcatsTransfer(accountID, acatsID)
  );
